/**
 * Every page as its template (#788 PR2): the browser's record names the page
 * it was on by this, never by its address — `/jobs/[key]`, not
 * `/jobs/greenhouse:123`, whose key names an employer and a posting.
 *
 * Written out rather than read from Next: the router's own patterns arrive
 * only for the page being left, and only behind an experimental switch.
 * The list and `pageOf` are lib/domain/pages.ts, shared with the server.
 *
 * Imports nothing: the browser runs it.
 */
export { PAGE_ROUTES, pageOf, type PageRoute } from "@/lib/domain/pages";

/** Pages whose own record is none: `/billing` is reached when the free week
 *  is over, and is not a page to study (BLUEPRINT §21). */
export const UNRECORDED_PAGES: ReadonlySet<string> = new Set(["/billing", "/logout"]);
